import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/CardsLeftImage.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class Cards extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, assets_path, className, title, rtext } = this.props,
    { show_feedback } = this.state

    return (
      <section className={`${styles.section} ${styles[className]}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={``}
            />
          }
          <div className={styles.list}>
            {list.map( ( elm, k ) => (
              <div className={styles.block}>
                <Image className={styles.block_image} src={elm?.image} width={213} height={194} alt={elm?.name} />
                <div className={rtext == 1 ? styles.rtext : styles.rtext2}>
                  <div className={styles.rtext_title} dangerouslySetInnerHTML={{__html: elm?.name}} />
                  <div className={styles.rtext_iconblock}>
                    <Image src={`/${assets_path}/images/empty-wallet.svg`} width={24} height={24} alt={`Ц`} />
                    <div>
                      <div className={styles.rtext_iconblock_title}>Цена</div>
                      <div className={styles.rtext_iconblock_text} dangerouslySetInnerHTML={{__html: elm?.price}} />
                    </div>
                  </div>
                  <div className={styles.rtext_iconblock}>
                    <Image src={`/${assets_path}/images/maximize.svg`} width={24} height={24} alt={`Р`} />
                    <div>
                      <div className={styles.rtext_iconblock_title}>Размеры</div>
                      <div className={styles.rtext_iconblock_text} dangerouslySetInnerHTML={{__html: elm?.size}} />
                    </div>
                  </div>
                  <div className={styles.rtext_btn}>
                    <GreenButton
                      text={`Подробнее`}
                      width={113}
                      action={() => this.showFeedback()}
                    />
                  </div>
                </div>
              </div>
            ) )}
          </div>
        </Container>
        <FeedbackForm
          title={`Пластиковые окна`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

Cards.propTypes = {
  list: PropTypes.array,
  assets_path: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  rtext: PropTypes.number
}

Cards.defaultProps = {
  list: [],
  assets_path: ``,
  className: `t20`,
  title: ``,
  rtext: 1
}

export default Cards